/**
 * A map of element IDs.
 * NOTE: Easier to change one place than multiple.
 *
 * @type {Object}
 */
export const ELEMENT_IDS = {
    AppWrapper: 'app_wrapper',
};
